import { render } from "./MissedOpportunityDetailComponent.vue?vue&type=template&id=2dbb19ac"
import script from "./MissedOpportunityDetailComponent.vue?vue&type=script&lang=js"
export * from "./MissedOpportunityDetailComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/lbhq_agencyportal_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__